      <div class="inner-page-bg-right">
  <div > 
  <header data-aos="zoom-in">
    <div class="container">
      <div class="row-custom">
        <div class="col-sm-12-custom">
          <div class="inner-header">
            <div class="logo"> <a href="index.html"> 
             <img src="assets/crm_images/logo-inner.png" alt="" />

           </a> </div>
            <div class="menus">
              <nav class="animenu" role="navigation" aria-label="Menu">
                <button class="animenu__btn" type="button"> <span class="animenu__btn__bar"></span> <span class="animenu__btn__bar">
                </span> <span class="animenu__btn__bar"></span> </button>
                <ul class="animenu__nav">
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  
  <section class="terms-content">
            <div class="container">
                <div class="terms-container">
                    <h1>Terms of Service and End User License Agreement</h1>

                    <p><strong>PLEASE READ CAREFULLY</strong> — By accessing or using Scanfluence's website,
                        applications, or services (the "Services"), you agree to comply with and be bound by this
                        unified Terms of Service and End User License Agreement (the "Agreement"). If you do not agree,
                        do NOT use the Services.</p>

                    <h2>1. Definitions</h2>
                    <p>"Scanfluence" refers to the company providing the Services. "Customer" or "User" refers to any
                        person or entity accessing the Services. "Software" refers to Scanfluence's web applications,
                        mobile apps, connectors, and downloadable tools.</p>

                    <h2>2. License Grant</h2>
                    <p>Scanfluence grants you a limited, non-exclusive, non-transferable, revocable license to access
                        and use the Software for legitimate business purposes only, in compliance with this Agreement
                        and applicable laws. You may not resell, redistribute, reverse engineer, or create derivative
                        works of the Software.</p>

                    <h2>3. Acceptable Use and Restricted Businesses</h2>
                    <p>You must not use the Services for illegal, harmful, or inappropriate activities. Restricted
                        businesses include:</p>
                    <ul>
                        <li>Illegal products or services</li>
                        <li>Adult content and escort services</li>
                        <li>Gambling, betting, lottery</li>
                        <li>Controlled substances without proper licensing</li>
                        <li>Weapons, ammunition, explosives</li>
                        <li>Counterfeit or IP-infringing goods</li>
                        <li>High-risk financial schemes (unregulated investments, MLM)</li>
                        <li>Deceptive marketing or fraudulent promotions</li>
                        <li>Violent, hateful, or extremist organizations</li>
                        <li>Spam, phishing, or unauthorized mass messaging</li>
                        <li>Occult and esoteric services: astrology, psychic readings, tarot, fortune-telling, spiritual
                            healing</li>
                        <li>Unlicensed health or medical services</li>
                        <li>Cryptocurrency and unregulated financial products</li>
                        <li>Social media manipulation (fake reviews, followers, engagement)</li>
                        <li>High-risk travel and event services</li>
                        <li>Political campaigning and lobbying without approval</li>
                        <li>Unregistered charities and fundraising</li>
                        <li>Tobacco and vaping products</li>
                        <li>Fireworks and pyrotechnics</li>
                        <li>Pyramid schemes and 'get rich quick' programs</li>
                        <li>Sensitive/adult dating services</li>
                    </ul>
                    <p>Scanfluence reserves the right to refuse or terminate accounts engaging in these activities.</p>

                    <h2>4. User Responsibilities</h2>
                    <p>You are responsible for maintaining the confidentiality of your account credentials and all
                        activities under your account. You must provide accurate information and promptly update it if
                        changes occur. Any misrepresentation or attempt to bypass restrictions will result in immediate
                        termination.</p>

                    <h2>5. Payment, Renewal, and Cancellation</h2>
                    <p>Fees are billed according to Scanfluence's published pricing schedule. Subscriptions
                        automatically renew unless canceled via account settings or by written request to
                        support@scanfluence.com. Refunds are provided only where legally required or at Scanfluence's
                        discretion.</p>

                    <h2>6. Disclaimer of Warranties</h2>
                    <p>The Services are provided 'AS IS' and 'AS AVAILABLE' without warranties of any kind. Scanfluence
                        disclaims all express, implied, statutory, or other warranties, including merchantability,
                        fitness for a particular purpose, and non-infringement. We do not warrant that the Services will
                        be uninterrupted, error-free, secure, or that data will be preserved without loss.</p>

                    <h2>7. Limitation of Liability</h2>
                    <p>The total liability of Scanfluence, its affiliates, directors, officers, employees, and agents
                        shall not exceed the fees you paid in the six (6) months preceding the claim. We are not liable
                        for indirect, incidental, special, consequential, or punitive damages, including loss of
                        profits, data, goodwill, or business opportunities. We are not responsible for damages or
                        disputes arising from third-party integrations, connectors, or merchant systems connected to the
                        Services.</p>

                    <h2>8. Indemnification</h2>
                    <p>You agree to indemnify, defend, and hold harmless Scanfluence and its affiliates from any claims,
                        damages, or expenses arising out of your use of the Services, including campaigns, content, or
                        third-party integrations you operate or distribute.</p>

                    <h2>9. Intellectual Property Rights</h2>
                    <p>All intellectual property rights in the Services, Software, and related content remain the
                        exclusive property of Scanfluence. You may not copy, reproduce, modify, distribute, or create
                        derivative works without prior written consent.</p>

                    <h2>10. Data Protection and Privacy</h2>
                    <p>Scanfluence respects your privacy and complies with applicable data protection laws, including
                        GDPR and PIPEDA. Our Privacy Policy explains how we collect, use, and protect your personal
                        information.</p>

                    <h2>11. End User Data</h2>
                    <p>You own all data you input into the Services ("End-User Provided Data"). Scanfluence treats this
                        data as confidential and uses it only for delivering the Services, support, security, or as
                        required by law.</p>

                    <h2>12. Suspension and Termination</h2>
                    <p>Scanfluence may suspend or terminate your account immediately if you breach this Agreement,
                        engage in restricted activities, or misuse the Services. You may terminate your account by
                        written notice or via account settings.</p>

                    <h2>13. Force Majeure</h2>
                    <p>Scanfluence is not liable for delays or failures caused by events beyond its control (e.g.,
                        natural disasters, cyberattacks, outages, regulatory actions), provided reasonable mitigation is
                        attempted.</p>

                    <h2>14. Modifications to Services and Agreement</h2>
                    <p>Scanfluence may update or modify the Services or this Agreement at any time. Continued use of the
                        Services after changes are posted constitutes acceptance of the updated Agreement.</p>

                    <h2>15. Governing Law and Jurisdiction</h2>
                    <p>This Agreement is governed by the laws of the Province of Ontario, Canada. Any disputes shall be
                        subject to the exclusive jurisdiction of the courts in Ontario.</p>

                    <h2>16. Contact Information</h2>
                    <div class="contact-info">
                        <p>For any questions or concerns regarding this Agreement, please contact:</p>
                        <p><strong>Scanfluence Management</strong><br>
                            3600 Steeles Avenue East<br>
                            Markham, ON, L3R 9Z7<br>
                            Email: legal@scanfluence.com<br>
                            Phone: +1 (437) 826 7226</p>
                    </div>
                </div>
            </div>
        </section>

            </div>
                </div>